// @flow strict

import React, { Component } from 'react';
import type { Element, Node, ChildrenArray } from 'react';
import { connect } from 'react-redux';
import { type StepType, setStep } from '../actions/step';

type Props = {
  children: Element<'div'> | Node | ChildrenArray<Node>,
  descriptKey: string,
  index: number,
  pathName?: string | null,
  section?: number,
  setStep: (number, string, ?string, ?number) => StepType,
};

class FunnelStep extends Component<Props> {
  static defaultProps = {
    pathName: null,
    section: 0,
  };

  UNSAFE_componentWillMount() {
    const { index, descriptKey, pathName, section } = this.props;

    this.props.setStep(index, descriptKey, pathName, section);
  }

  render() {
    return <div>{this.props.children}</div>;
  }
}

export default connect(null, { setStep })(FunnelStep);
